import React, { useContext, useEffect, useState } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import organisms from '../../../../components/organisms'
import service from '../../../../api/services'
import { HeaderHeading } from '../../../../Context'
import { BrandDataProps } from '../../../../components/organisms/Data/Brand/interface'
import { useLocation } from 'react-router'
import { useToasts } from 'react-toast-notifications'


const { Brand } = organisms
const Index = () => {
    const location = useLocation();
    const {addToast} = useToasts()
    const [search, setSearch] = useState<any>('');
    const [brandData, setBrandData] = useState<BrandDataProps[]>([])
    const { setHeader,setSidebar }: any = useContext(HeaderHeading);
    const urlParams = new URLSearchParams(location.search);
    const typeValue = urlParams?.get('brand-type')
    const getBrandList = async () => {
        try {
            let response = await service.productData.brandListingService({ "search": search,brand_category:typeValue })
            if (response.status === 200) {
                setBrandData(response.data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(()=>{
        setBrandData([])
        setSearch('')
    },[typeValue])
    useEffect(() => {
        setHeader("Content - Brands")
       
        setSidebar(false)
        getBrandList()
    }, [search,typeValue])
    const deleteBrand = async (id: string) => {
        try {
            let response = await service.productData.deleteBrandService(id)
            if( response?.status === 200 || response?.status === 201) {
                getBrandList()
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    return (
        <Wrapper>
            <Brand
                setSearch={setSearch}
                brandData={brandData}
                setBrandData={setBrandData}
                search={search}
                deleteBrand={(id: string) => deleteBrand(id)}
            />
        </Wrapper>
    )
}
export default Index